module.exports = __webpack_public_path__ + "img/vippack_dg_k.71e040a1.png";